export default "__VITE_ASSET__14f28760__"